import React from "react";
import { Link } from "react-router-dom";
import { useTheme } from "@mui/material/styles";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import PublicPageLayout from "../public-site/PublicPageLayout";
import { getPublicSiteSx } from "../public-site/publicSiteStyles";

export default function NotFound() {
  const theme = useTheme();
  const sx = React.useMemo(() => getPublicSiteSx(theme), [theme]);

  return (
    <PublicPageLayout
      eyebrow="404"
      title="That page does not exist."
      description="The page you were looking for may have moved, expired, or never existed."
    >
      <Box sx={sx.callout}>
        <Typography sx={sx.sectionCopy}>
          Try heading back to the homepage or continue with one of Ouro's main
          public sections.
        </Typography>
        <Box
          sx={{
            mt: 3,
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: 1.5,
          }}
        >
          <Button component={Link} to="/" variant="contained" sx={sx.primaryButton}>
            Go home
          </Button>
          <Button component={Link} to="/how-it-works" variant="outlined" sx={sx.secondaryButton}>
            See how Ouro works
          </Button>
        </Box>
      </Box>
    </PublicPageLayout>
  );
}
